"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dispatch_1 = require("./dispatch");
var corePlugins = [
    dispatch_1.default
];
exports.default = corePlugins;
//# sourceMappingURL=index.js.map